import axios from './providers/axios';

const inviteService = {
    getInvitedUsers(page, companyId) {
        console.log(companyId);
        return axios.get(`/v1/admin/user/invited/store?list=true&companyId=${companyId}`)
            .then(res => {
                return {
                    data: res.data.data
                };
            });
    },
    inviteUser(data) {
        return axios.post('/v1/admin/user/invited/add', data);
    },
    deleteInvite(id) {
        return axios.delete(`/v1/admin/user/invited/delete/${id}`);
    },
    resendInvite(userId) {
        return axios.post(`/v1/admin/user/invited/resend/${userId}`);
    }
}

export default inviteService;
